<template>
  <div v-if="!init_status" class="h-screen flex flex-wrap content-center">
    <div v-if="!error" class="p-12 border rounded-lg shadow-lg mx-auto">
      Daten werden geladen ...
    </div>
    <div v-else class="p-12 border rounded-lg shadow-lg mx-auto">
      <h1 class="text-lg font-semibold">Entschuldigen Sie bitte die Unannehmlichkeiten.</h1>
      <p class="mt-4">
        Beim Verbindungsaufbau ist ein Problem aufgetreten.
        Bitte versuchen Sie neu zu laden oder probieren Sie
        es bitte später nochmal.
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['init_status', 'error'])
  },
}
</script>
